module.exports = __webpack_public_path__ + "img/1557940548.a120b28b.jpg";